"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scanImageData = exports.scanRGBABuffer = exports.scanGrayBuffer = exports.getDefaultScanner = void 0;

var Image_1 = require("./Image");

var ImageScanner_1 = require("./ImageScanner");

var defaultScannerPromise = ImageScanner_1.ImageScanner.create();
exports.getDefaultScanner = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return defaultScannerPromise;

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));

var scanImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(image, scanner) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(scanner === undefined)) {
              _context2.next = 4;
              break;
            }

            _context2.next = 3;
            return defaultScannerPromise;

          case 3:
            scanner = _context2.sent;

          case 4:
            res = scanner.scan(image);

            if (!(res < 0)) {
              _context2.next = 7;
              break;
            }

            throw Error('Scan Failed');

          case 7:
            if (!(res === 0)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", []);

          case 9:
            return _context2.abrupt("return", image.getSymbols());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function scanImage(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.scanGrayBuffer = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buffer, width, height, scanner) {
    var image, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Image_1.Image.createFromGrayBuffer(width, height, buffer);

          case 2:
            image = _context3.sent;
            _context3.next = 5;
            return scanImage(image, scanner);

          case 5:
            res = _context3.sent;
            image.destroy();
            return _context3.abrupt("return", res);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

exports.scanRGBABuffer = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(buffer, width, height, scanner) {
    var image, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Image_1.Image.createFromRGBABuffer(width, height, buffer);

          case 2:
            image = _context4.sent;
            _context4.next = 5;
            return scanImage(image, scanner);

          case 5:
            res = _context4.sent;
            image.destroy();
            return _context4.abrupt("return", res);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x7, _x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

exports.scanImageData = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(image, scanner) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return exports.scanRGBABuffer(image.data.buffer, image.width, image.height, scanner);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();